<template>
  <vue-form :state="formState" class="step-two" id="step-two">
    <h2 class="fs-24 font-smoothing">Bagageinformation</h2>
    <step>
      <div>
        <p class="fs-14 color-grey-3 font-smoothing step-description">Fulde navn skal angives på ALLE personer der skal tjekkes ind også selvom de ingen bagage har med. Fordel desuden den valgte mængde bagage og beskriv, i tilfælde af stor bagage, hvilken type der er tale om.<br>Husk at fx skistøvletaske og skitaske skal angives som to individuelle tasker.</p>
          <person
            v-for="(person, index) in people"
            :data_person="person"
            :key="person.id"
            :index="index"
            :moreThanOnePerson="people.length > 1 ? true : false"
          />
      </div>
      <button type="button" class="add-person" @click="incrementPeople">
        <div class="add-person__inner">
          <span class="add-persion__icon"></span>
          <span class="add-person__text">Tilføj rejsende</span>
        </div>
      </button>

      <!-- Responsible Person Section -->
      <div v-if="people.length >= 1 && includeHome" class="responsible-person-section">
        <h3 class="responsible-person-title">Hvem er ansvarlig for bagagen ved retur til København</h3>
        <div class="responsible-person-options">
          <div 
            v-for="person in people" 
            :key="`responsible-${person.id}`"
            class="radio-option"
            @click="setResponsiblePerson(person.id)"
          >
            <input 
              type="radio" 
              :value="person.id"
              :checked="responsiblePersonId === person.id"
              readonly
            />
            <label>{{ getPersonName(person) || `Person ${person.id}` }}</label>
          </div>
        </div>
      </div>
    </step>

    <div class="luggage-description" v-if="hasLargeLuggage">
      <div class="mb-4">
        <p class="color-grey-3 fs-14 font-smoothing mb-2">Har du booket en Airshell i lufthavnen? Så kan vi have den med:</p>
        <div class="luggage-small">
          <input-number :number="this.luggageAirshell.amount" @setLuggage="setLuggage($event, 'luggageAirshell')" @increment="addLuggage('luggageAirshell')" @decrement="removeLuggage('luggageAirshell')"/>
        </div>
      </div>
      <div class="mb-4">
        <p class="color-grey-3 fs-14 font-smoothing mb-2">Kraftig plastpose til klapvogne og lignende:</p>
        <div class="luggage-small">
          <input-number :number="this.luggagePlasticBag.amount" @setLuggage="setLuggage($event, 'luggagePlasticBag')" @increment="addLuggage('luggagePlasticBag')" @decrement="removeLuggage('luggagePlasticBag')"/>
        </div>
      </div>

      <div>
        <p class="color-grey-3 fs-14 font-smoothing">Beskriv herunder hvilke typer stor bagage der er tale om</p>
        <textarea class="outline-none w-100 p-3 fs-14 color-grey-3" v-model="luggageDescription" rows="5" required name="luggageDescription"></textarea>
      </div>
    </div>
  </vue-form>
</template>

<script>
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'
import { mapGetters, mapMutations } from 'vuex'
import { page } from 'vue-analytics'
import Person from '@/components/Person'
import Step from '@/components/Step'
import InputNumber from '@/components/InputNumber'

export default {
  name: 'StepTwo',
  data() {
    return {
      formState: {},
      baggage: 0
    }
  },
  methods: {
    ...mapMutations(['incrementPeople', 'setResponsiblePerson']),

    getPersonName(person) {
      if (person.firstName && person.lastName) {
        return `${person.firstName} ${person.lastName}`
      } else if (person.firstName) {
        return person.firstName
      } else if (person.lastName) {
        return person.lastName
      }
      return ''
    },
    setLuggage(amount, luggageType) {
      if (luggageType === 'luggagePlasticBag') {
        this.luggagePlasticBag.amount = Number(amount);
      } else if (luggageType === 'luggageAirshell') {
        this.luggageAirshell.amount = Number(amount);
      }
    },
    addLuggage(prop) {
      if(prop === 'luggageAirshell') {
        this.luggageAirshell.amount++;
      } else if(prop === 'luggagePlasticBag') {
        this.luggagePlasticBag.amount++;
      }
    },
    removeLuggage(prop) {
      if(prop === 'luggageAirshell') {
        if (this.luggageAirshell.amount > 0 ) this.luggageAirshell.amount--;
      } else if(prop === 'luggagePlasticBag') {
        if (this.luggagePlasticBag.amount > 0 ) this.luggagePlasticBag.amount--;
      }
    },
    // Check if we visit the page for the first time
    setBagsCount () {
      this.people.forEach(person => {
        if (person.luggageSmall > 0 || person.luggageLarge > 0) {
          this.baggage = 1
        }
      })
    }
  },
  mounted () {
    this.setBagsCount()
    if (this.baggage === 0) {
      this.people[0].luggageSmall = Number(this.luggageSmall.amount)
      this.people[0].luggageLarge = Number(this.luggageLarge.amount)
    }
    page('/stepTwo')
  },
  computed: {
    ...mapMultiRowFields(['cart.people']),
    ...mapGetters(['cart']),
    ...mapFields(['cart.luggageDescription', 'cart.luggageAirshell', 'cart.luggagePlasticBag', 'cart.luggageSmall', 'cart.luggageLarge', 'cart.includeHome']),
    responsiblePersonId() {
      return this.cart.responsiblePersonId
    },
    hasLargeLuggage() {
      return this.people.some(person => person.luggageLarge > 0)
    },
    invalid() {

      if(this.personsInvalid) {
        this.$emit('invalid');
        return true;
      } else if(this.formState.$invalid) {
       this.$emit('invalid');
        return true;
      } else {
        this.$emit('valid');
        return false;
      }
    },
    personsInvalid(){
      if (this.people.some(person => person.firstName == '')) return true;

      if (this.people.some(person => person.lastName == '')) return true;

      return false;
    }
  },
  watch: {
    invalid(invalid) {
      if (invalid) {
        this.$emit('invalid')
      } else {
        this.$emit('valid')
      }
    }
  },
  components: {
    Person,
    Step,
    InputNumber,
  }
}
</script>

<style lang="scss">
  @use "../assets/scss/variables" as *;

  .step-two {
    padding: 60px 0 0;

    .input-number .increment, .input-number .decrement{
      background: white;
    }

    h2 {
      padding-left: 80px;
      margin-bottom: 60px;
    }

    .step-description {
      max-width: 440px;
    }

    .header {
      p:first-child {
        width: calc(100% - 320px);
      }

      p:not(:first-child) {
        width: 120px;
        margin-right: 15px;
      }
    }

    .luggage-description {
      padding: 60px 80px;

      textarea {
        border: 1px solid $grey-1;
        resize: none;
      }
    }

    .add-person {
      background-color: transparent;
      outline: none;
      font-size: 14px;
      color: $grey-3;
      margin-top: 20px;
      padding: 0;
      border: none;
      outline: none;
      cursor: pointer;
    }

    .add-person__inner {
      display: flex;
      align-items: center;
    }

    .add-persion__icon {
      border-right: 1px solid $grey-1;
      width: 20px;
      height: 100%;
      display: flex;
      justify-content: center;
      position: relative;
      margin-right: 10px;

      &:before,
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        width: 10px;
        height: 1px;
        background-color: $grey-3;
      }

      &:before {
        transform: rotate(90deg);
      }
    }

    .responsible-person-section {
      margin-top: 40px;
      padding: 30px 0;
      border-top: 1px solid $grey-1;

      .responsible-person-title {
        font-size: 18px;
        font-weight: 600;
        color: $blue-2;
        margin-bottom: 10px;
      }

      .responsible-person-description {
        font-size: 14px;
        color: $grey-3;
        margin-bottom: 20px;
        line-height: 1.4;
      }

      .responsible-person-options {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .radio-option {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 12px 16px;
          border: 1px solid $grey-1;
          border-radius: 6px;
          transition: all 0.3s ease;

          &:hover {
            border-color: #00A9E0;
            background-color: #f8fbff;
          }

          input[type="radio"] {
            margin-right: 12px;
            cursor: pointer;
            
            &:checked + label {
              color: #00A9E0;
              font-weight: 600;
            }
          }

          label {
            font-size: 14px;
            color: $grey-3;
            cursor: pointer;
            margin: 0;
            transition: color 0.3s ease;
          }

          &:has(input:checked) {
            border-color: #00A9E0;
            background-color: #f8fbff;
          }
        }
      }
    }

    @media (max-width: 768px) {
      .responsible-person-section {
        margin-top: 30px;
        padding: 20px 0;

        .responsible-person-title {
          font-size: 16px;
        }

        .responsible-person-description {
          font-size: 13px;
        }
      }
    }
  }
</style>
